/* Pairs theme: auto-fit product card images.
   Measures where the product actually sits in each photo (ignoring the
   background) and scales/positions it so every product in the grid has the
   same width, the same baseline and is centred. Results are cached per image. */
(function () {
  var TARGET_W = 0.82;   // product width as a share of the card
  var MAX_H = 0.56;      // cap on product height as a share of the card
  var BASELINE = 0.80;   // where the bottom of the product sits (from the top)
  var KEY = 'pp-fit-v2';
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) {}
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(cache)); } catch (e) {} }

  function keyFor(src) { return src.split('?')[0]; }

  function measure(im) {
    var n = 140, r = im.naturalWidth / im.naturalHeight;
    if (!r) return null;
    var w = r >= 1 ? n : Math.max(1, Math.round(n * r));
    var h = r >= 1 ? Math.max(1, Math.round(n / r)) : n;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(im, 0, 0, w, h);
    var d;
    try { d = ctx.getImageData(0, 0, w, h).data; } catch (e) { return null; }
    var pts = [[0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1]];
    var br = 0, bg = 0, bb = 0, ba = 0;
    pts.forEach(function (p) { var i = (p[1] * w + p[0]) * 4; br += d[i]; bg += d[i + 1]; bb += d[i + 2]; ba += d[i + 3]; });
    br /= 4; bg /= 4; bb /= 4; ba /= 4;
    var transparent = ba < 128;
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4, a = d[i + 3], hit;
        if (transparent) hit = a > 40;
        else hit = a > 128 && (Math.abs(d[i] - br) + Math.abs(d[i + 1] - bg) + Math.abs(d[i + 2] - bb)) > 45;
        if (hit) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
    }
    if (x1 < 0) return null;
    var b = [x0 / w, y0 / h, (x1 + 1) / w, (y1 + 1) / h, r, 0];
    // Ignore results that look wrong (e.g. lifestyle photos filling the frame)
    if ((b[2] - b[0]) > 0.98 && (b[3] - b[1]) > 0.98) return null;
    // Light grey background: remember its level so it can be lifted to white
    if (!transparent) {
      var lvl = (br + bg + bb) / 3, spread = Math.max(br, bg, bb) - Math.min(br, bg, bb);
      if (lvl >= 200 && lvl < 250 && spread < 14) b[5] = lvl;
    }
    return b;
  }

  // Brand tiles (taller than wide, label along the bottom)
  var TILE_W = 0.80, TILE_MAX_H = 0.46, TILE_BASE = 0.71;
  function applyTile(img, b) {
    var box = img.parentNode, A = box.clientHeight / box.clientWidth || 1.25;
    var r = b[4];
    var k = Math.min(TILE_W / ((b[2] - b[0]) * r), (TILE_MAX_H * A) / (b[3] - b[1]));
    var cx = (b[0] + b[2]) / 2 * r;
    if (img.classList.contains('tile__img--flip')) cx = r - cx;
    var st = img.style;
    st.padding = '0'; st.objectFit = 'fill'; st.inset = 'auto'; st.maxWidth = 'none';
    st.width = (r * k * 100) + '%';
    st.height = (k / A * 100) + '%';
    st.left = ((0.5 - cx * k) * 100) + '%';
    st.top = ((TILE_BASE * A - b[3] * k) / A * 100) + '%';
    if (b[5]) st.filter = 'brightness(' + (255 / b[5]).toFixed(3) + ')';
    img.classList.add('is-fit');
  }

  function apply(img, b) {
    if (img.classList.contains('tile__img')) return applyTile(img, b);
    var r = b[4];
    var bw = (b[2] - b[0]) * r, bh = b[3] - b[1];
    var s = Math.min(TARGET_W / bw, MAX_H / bh);
    var cx = (b[0] + b[2]) / 2 * r;
    if (img.classList.contains('card__img--flip')) cx = r - cx;
    var st = img.style;
    st.padding = '0'; st.objectFit = 'fill'; st.inset = 'auto'; st.maxWidth = 'none';
    st.width = (r * s * 100) + '%';
    st.height = (s * 100) + '%';
    st.left = ((0.5 - cx * s) * 100) + '%';
    st.top = ((BASELINE - b[3] * s) * 100) + '%';
    if (b[5]) st.filter = 'brightness(' + (255 / b[5]).toFixed(3) + ')';
    img.classList.add('is-fit');
  }

  function fit(img) {
    if (img.dataset.fitDone) return;
    img.dataset.fitDone = '1';
    var src = img.currentSrc || img.src;
    if (!src) return;
    var k = keyFor(src);
    if (cache[k]) { apply(img, cache[k]); return; }
    if (cache[k] === 0) return;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var b = measure(probe);
      cache[k] = b || 0; save();
      if (b) apply(img, b);
    };
    probe.src = src.indexOf('width=') > -1 ? src.replace(/width=\d+/, 'width=300') : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
  }

  function scan(root) {
    (root || document).querySelectorAll('.card__media img.card__img, .tile__media img.tile__img').forEach(fit);
  }

  function init() {
    scan();
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
